import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { PortService } from 'src/app/core-services/port.service';
import { IdViewModel } from 'src/app/models/IdViewModel';
import { SearchBy, UserRole, UserSelectedPlan, ShippingLineRroute, DataParam, OpenSearchScreen, OpenSearchFinderFields } from 'src/app/Enum/Enum';
import { Port } from 'src/app/models/Port';
import { Country } from "src/app/models/Country";
import { Transittime } from 'src/app/models/Transittime';
import { ActivatedRoute, Router } from '@angular/router';
import { QuickestSearchModel } from 'src/app/models/QuickestSearchModel';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { getLocaleMonthNames } from '@angular/common';
import { Paginator } from 'primeng/paginator';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { LandingPageSearchModel } from "src/app/models/LandingPageSearchModel";
import * as moment from 'moment';

import { openLoginModal } from 'src/app/core-services/eventEmitter';
import { ConfirmationService } from 'primeng/api';
import { PlanService } from '../services/plan.service';
import { OpenSearchService } from '../services/open-searches.service';
import { Result } from 'src/app/models/ResultModel';
import { FreeSearchConfigVM } from '../../admin/open-searches/model/open-search.model';
import { OpenSearchModel } from '../../admin/open-searches/model/open-search.model';
import { Options } from '@angular-slider/ngx-slider';
@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  providers: [
    ConfirmationService
  ]
})
export class SearchResultComponent implements OnInit {
  showloader: boolean = false;
  data: any;
  searchResult: any;
  hozizontaldata: any;
  optionsquick: any;
  options: any;
  portsData: Port[] = [];
  quckestsearchdata: any;
  chepestsearchdata: any;
  //stateParams: any;
  logos: string[];
  shippingLines: any[];
  selectedShipLines: any[] = [];
  shippingLineName: string[] = [];
  shippingIds: string;
  Quickestserchres: QuickestSearchModel[] = [];
  chepestserchres: QuickestSearchModel[] = [];
  totalCount: number;
  submitted: boolean = false;
  Val: number = 0;
  Optionsarr: any;
  dateRange: Date[] = [];
  depselectedDate: Date[] = [];
  minDate: Date;
  rageYears: string;
  valueArrival: number;
  valueDep: number;
  arroption: Options = {};
  OptionsDep: Options = {};
  IsFilter: boolean = false;
  toportarrivalladd30days: Date;
  fromportarrivaladd30days: Date;
  fromPortSliderSelectedDate: string;
  toPortSliderSelectedDate: string;
  selectedShipIds: number[] = [];
  transhipmentPorts: any[] = [];
  selectedTranshipmentPort: any;
  filterFlag: number;
  quickest: number;
  earliest: number;
  cheapest: number;
  currentPage: number;
  pageSize: number;
  timeFlag: boolean = false;
  departurePortName: string;
  arrivalPortName: string;
  newDate: string;
  isSignedIn: boolean = false;
  planText: string;
  isPermission: boolean = false;
  totalSearchCount: number = 0;
  isBasicPlan: boolean = false;
  isSearch: boolean = true;
  currentUserDetails: any;
  userDetailsId: number = 0;
  scheduleRroute: number = 0;
  tap: number = SearchBy.Earliest;
  masterDestinationCountries: Country[] = [];
  masterDestinationPorts: any[] = [];
  masterSourceCountries: Country[] = [];
  masterSourcePorts: any[] = [];
  yesButtonText = 'Yes';
  noButtonText = 'No'
  landingPageSearch: LandingPageSearchModel;
  isFreeSearchesFinished = false;
  autoTranshipmentSearch = false;
  enableTracking = false;
  openSearches: OpenSearchModel[]=[];
  isOpenSearchEnabled= false;

  searchForm = this.fb.group({
    toCountry: [""],
    fromCountry: [""],
    fromPort: [''],
    toPort: [''],
    date: ['']
  });

  isCountrySearch=false;
  math = Math;
  constructor(private fb: FormBuilder, private portService: PortService, private activatedRoute: ActivatedRoute
    , private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService,
    private planService: PlanService,
    private confirmationService: ConfirmationService,
    private openSearchService:OpenSearchService) {
    this.options = this.toastr.toastrConfig;
    this.options.positionClass = 'toast-top-center';

    let landingSearchJson = localStorage.getItem(DataParam.LandingPageSearch.toString());
    if (landingSearchJson != "" && landingSearchJson != null) {
      this.landingPageSearch = JSON.parse(landingSearchJson);
      this.isCountrySearch=this.landingPageSearch.isCountrySearch;
    } else {
      this.landingPageSearch = {
        date: new Date().toDateString(),
        toCountryId: 0,
        toPortIds: [],
        fromCountryId: 0,
        fromPortIds: [],
        isSearch: false,
        searchBy: SearchBy.EarliestArrival,
        isCountrySearch:false
      };
      this.isCountrySearch=false;
    }

    this.activatedRoute.data.subscribe((params: any) => {
      //this.stateParams = params.params;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });

    var currentUser = localStorage.getItem('currentUser');
    if (currentUser != null && currentUser != undefined) {
      this.isSignedIn = true;
      this.currentUserDetails = JSON.parse(currentUser);
      if (this.currentUserDetails != null && this.currentUserDetails.usersDetailsVM != null && (this.currentUserDetails.usersDetailsVM.userRole != null && this.currentUserDetails.usersDetailsVM.userRole != '')) {
        if (this.currentUserDetails.usersDetailsVM.userRole == UserRole.SuperAdmin) {
          this.enableTracking = true;
        }
        else if (this.currentUserDetails.usersDetailsVM.userRole == UserRole.User) {
          this.getPlanDetails(this.currentUserDetails.usersDetailsVM.planId)
          if (this.currentUserDetails.usersDetailsVM.planId != null && this.currentUserDetails.usersDetailsVM.planId == UserSelectedPlan.Basic) {
            this.isPermission = true;
            this.totalSearchCount = this.currentUserDetails.usersDetailsVM.totalSearchCount;
            this.isBasicPlan = true;
            this.userDetailsId = this.currentUserDetails.usersDetailsVM.id;
          }
        }
      }
    }
    else {
      this.userDetailsId = 0;
    }
  }
  @ViewChild('p') paginator: Paginator;

  ngOnInit() {
    this.getOpenSearches();
    this.currentPage = 1;
    this.pageSize = 20;
    this.filterFlag = SearchBy.Earliest;
    this.quickest = SearchBy.Quickest;
    this.earliest = SearchBy.Earliest;
    this.cheapest = SearchBy.Cheapest;
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);

    let landingSearchJson = localStorage.getItem(DataParam.LandingPageSearch.toString());

    if (!landingSearchJson) {
      this.router.navigate(['/searchresultsplash']);
    }

    // var date = new Date(this.stateParams.date);
    var date = new Date(this.landingPageSearch.date);
    var numberOfDaysToAdd = 31;
    var newdate = date.setDate(date.getDate() + numberOfDaysToAdd);
    this.newDate = this.dateConvert(newdate);

    if (this.landingPageSearch.date != null && this.landingPageSearch.date != "") {
      // create Departure Slider
      // this.createSliderForDeparture(this.stateParams.date);
      this.createSliderForDeparture(this.landingPageSearch.date);
      // create Departure Slider
      this.createSliderForArrival(this.newDate);
    }

    //this.getDestinationCountries(true);
    // this.getDestinationPorts(this.landingPageSearch.toCountryId, true);
    // this.getSourceCountries(this.landingPageSearch.toCountryId,this.landingPageSearch.toPortIds, true);
    // this.getSourcePorts(this.landingPageSearch.fromCountryId,this.landingPageSearch.toPortIds, true);

    // this.getPortsData();
    this.getShippingLines();
    this.getSearchResult(true);
    //this.gettransittimedetails();

    // setTimeout(() => {
    //   if (this.searchResult != undefined && this.searchResult != null && this.searchResult.length == 0) {
    //     this.getscheduleRrouting(1);
    //   }
    // }, 5000);

    let newDate : any= new Date(this.landingPageSearch.date);
    this.searchForm.controls.date.setValue(newDate);
  }

  getPlanDetails(planId) {
    this.planService.GetPlanDetails(planId).subscribe((res: any) => {
      if (res && res.data.planCatDetails && res.data.planCatDetails.length) {
        const trackingRights = res.data.planCatDetails.filter(z => z.searchCategoryName == 'Tracking' && z.isActiveInPlan);
        if (trackingRights.length) {
          this.enableTracking = true;
        }
      }
    });
  }


  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  gettabDetails(flag) {
    this.selectedShipLines = [];
    this.tap = flag;
    //this.shippingIds = '';
    //this.timeFlag = false;
    // create Departure Slider
    // this.createSliderForDeparture(this.stateParams.date);
    // this.createSliderForDeparture(this.landingPageSearch.date);
    // create Departure Slider
    //this.createSliderForArrival(this.newDate);
    if (flag == SearchBy.Quickest) {
      this.currentPage = 1;
      this.isSearch = false;
      this.SortbyQuckestDetails();
    }
    else if (flag == SearchBy.Cheapest) {
      this.currentPage = 1;
      this.isSearch = false;
      this.SortbyChepestDetails();
    }
    else if (flag == SearchBy.Earliest) {
      this.currentPage = 1;
      this.isSearch = false;
      this.landingPageSearch.searchBy = SearchBy.Earliest;
      localStorage.setItem(DataParam.LandingPageSearch.toString(), JSON.stringify(this.landingPageSearch))
      this.getSearchResult();
    }
    else {
      this.currentPage = 1;
      this.isSearch = false;
      this.landingPageSearch.searchBy = SearchBy.EarliestArrival;
      localStorage.setItem(DataParam.LandingPageSearch.toString(), JSON.stringify(this.landingPageSearch))
      this.getSearchResult();
    }
  }

  gettransittimedetails() {
    var transit = new Transittime();
    transit.FromPortIds = this.landingPageSearch.fromPortIds.toString();//parseInt(this.stateParams.fromPortId);
    transit.ToPortIds = this.landingPageSearch.toPortIds.toString();//parseInt(this.stateParams.toPortId);
    transit.fromdate = this.landingPageSearch.date;//this.stateParams.date;
    transit.Transhipment = this.scheduleRroute;
    this.spinner.show();
    this.portService.GetTransitTimeDate(transit).subscribe((response: any) => {
      if (response != null && response.content != null) {
        // this.showloader = false;
        let res = response.content;
        this.data = {
          showInLegend: true,
          labels: res.lable,
          lableshov: res.lablehov,
          datasets: [
            {
              lablesfortip: res.voyageNameList,
              eta: res.eta,
              dep: res.dep,
              ves: res.vesselsName,
              label: 'Transit Time',
              //backgroundColor: '#6DCFD1',
              backgroundColor: '#3E7194',// set color to rectangle of bar chart
              borderColor: '#1E88E5',
              data: res.days,
            }
          ],
        },
          this.options = {
            responsive: true,
            legend: {
              itemStyle: {
                width: 3 // or whatever, auto-wrap
              },
              position: 'bottom',
              itemWrap: true
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: false,
                  gridLines: {
                    display: false,
                  },
                },
                ticks: {
                  fontColor: "", // this here
                },
              }],
              yAxes: [{
                display: false,
                gridLines: {
                  display: false,
                },
                ticks: {
                  callback: function (label) {
                    if (/\s/.test(label)) {
                      return label.split(" ");
                    } else {
                      return label;
                    }
                  }
                }
              }],
            },
            tooltips: {
              callbacks: {
                title: function (tooltipItem, data) {
                  return [data.lableshov[tooltipItem[0].index]];
                },
                label: function (tooltipItem, data) {
                  // tooltipItem.xLabel = "ss";
                  tooltipItem.label = data.lableshov[tooltipItem.index];
                  var label = data.datasets[tooltipItem.datasetIndex].label || '';
                  label += ': ' + Math.round(tooltipItem.yLabel) + ' Days';
                  //var value1 = data.datasets[tooltipItem.datasetIndex].lablesfortip[tooltipItem.index];
                  var eta = 'Arrival ' + data.datasets[tooltipItem.datasetIndex].eta[tooltipItem.index];
                  var ED = 'Departure ' + data.datasets[tooltipItem.datasetIndex].dep[tooltipItem.index];
                  var vesselsName = 'Vessel: ' + data.datasets[tooltipItem.datasetIndex].ves[tooltipItem.index];
                  return [label, vesselsName, ED, eta];
                }
              }
            },
            animation: {
              duration: 500,
              easing: "easeOutQuart",
              onComplete: function () {
                var ctx = this.chart.ctx;
                //ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontFamily, 'normal', Chart.defaults.global.defaultFontFamily);
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';

                this.data.datasets.forEach(function (dataset) {
                  for (var i = 0; i < dataset.data.length; i++) {
                    var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                      scale_max = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._yScale.min;
                    ctx.fillStyle = '#FFF'; // Set white color of text
                    var y_pos = model.y - 5;
                    // Note: The y value is reverse, it counts from top down
                    if ((scale_max - model.y) / scale_max >= 0.93)
                      y_pos = model.y;
                    //ctx.fillText(dataset.data[i], model.x, y_pos);
                    if (dataset.data[i] == 0) {
                      ctx.fillText("", model.x, 130);
                    }
                    else
                      // ctx.fillText(dataset.data[i]+' Days', model.x, 130);
                      ctx.fillText(dataset.data[i] + '', model.x, 110);
                    if (dataset.data[i] > 0) {
                      ctx.fillText('days', model.x, 125);
                    }
                  }
                });
              }
            },
          };
      }
      //this.spinner.hide();
    })
  }

  searchPorts(event, flag) {
    let portName = '';
    if (event != null && event.query != null && event.query != '') {
      if (event.query.length > 2) {
        portName = event.query;
      }
      else {
        this.portsData = [];
      }
    }
    else {
      if (flag == 'from') {
        if (this.searchForm.controls.fromPort.value != null && this.searchForm.controls.fromPort.value != '') {
          portName = (this.searchForm.controls.fromPort.value as any)?.portName;
        }
      }
      else {
        if (this.searchForm.controls.toPort.value != null && this.searchForm.controls.toPort.value != '') {
          portName = (this.searchForm.controls.toPort.value as any)?.portName;
        }
      }
    }
    if (event.query != '') {
      var data = {
        PortName: portName
      };
      this.portService.GetPortDataByName(data).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.portsData = response.content;
        }
        else {
          this.portsData = [];
        }
      })
    }
    else {
      this.getPortDatafordropdown();

    }
  }

  getSearchResult(isPageLoad = false) {
    if (this.landingPageSearch != null && this.landingPageSearch != undefined) {
      var searchdata = new IdViewModel();
      searchdata.searchBy = this.landingPageSearch.searchBy ? this.landingPageSearch.searchBy : 6;
      searchdata.pageNo = this.currentPage;
      searchdata.recPerPage = this.pageSize;
      searchdata.fromPortIds = this.landingPageSearch.fromPortIds?this.landingPageSearch.fromPortIds.toString():"";//parseInt(this.stateParams.fromPortId);
      searchdata.toPortIds = this.landingPageSearch.toPortIds?this.landingPageSearch.toPortIds.toString():"";//parseInt(this.stateParams.toPortId);
      searchdata.isBasicSearch = (this.isSearch == true && this.isBasicPlan == true) ? String(this.landingPageSearch.isSearch) : 'false';
      searchdata.userDetailsId = this.userDetailsId;
      searchdata.transhipment = this.scheduleRroute;
      searchdata.FromCountryId=this.landingPageSearch.fromCountryId;
      searchdata.ToCountryId=this.landingPageSearch.toCountryId;
      searchdata.midPortId = this.selectedTranshipmentPort != null ? this.selectedTranshipmentPort.midPortId : 0;
      if (this.timeFlag == true) {
        searchdata.searchDate = this.fromPortSliderSelectedDate;
        searchdata.toPortArrivalDate = this.toPortSliderSelectedDate;
      }
      else {
        searchdata.searchDate = this.landingPageSearch.date;
        searchdata.toPortArrivalDate = '';
      }

      searchdata.ShippingLineIds = (this.shippingIds == '' || this.shippingIds == null) ? '' : this.shippingIds;
      this.spinner.show();
      this.portService.SearchVoyages(searchdata,this.landingPageSearch.isCountrySearch).subscribe((response: any) => {
        this.toastr.clear();
        if (isPageLoad) {
          this.getSourceCountries(true);
          if(this.isCountrySearch){
          
          }else{ 
            this.getSourcePorts(this.landingPageSearch.fromCountryId, true);
            this.getDestinationCountries(this.landingPageSearch.fromCountryId, this.landingPageSearch.fromPortIds, true);
            this.getDestinationPorts(this.landingPageSearch.toCountryId, this.landingPageSearch.fromPortIds, true);
          }
          
        }
        if (response != null && response.succeeded == true && response.data != null) {
          this.quckestsearchdata = response.data.voyage;
          this.searchResult = response.data.voyage;
          if (response.data.voyage != null && response.data.voyage.length > 0) {

            // this.createSliderForArrival(this.searchResult[0].toPortArrivalDate);
            if (this.timeFlag != true) {
              this.createSliderForArrival(this.searchResult[0].toPortArrivalDate);
              // this.GetSliderarrivalandDep(this.fromPortSliderSelectedDate, this.searchResult[0].toPortArrivalDate);
            }
            else {
              // this.GetSliderarrivalandDep(this.searchResult[0].fromPortArrivalDate, this.searchResult[0].toPortArrivalDate);
            }
          }
          // if (this.currentUserDetails && this.currentUserDetails.usersDetailsVM.userRole == UserRole.User && searchdata.isBasicSearch && this.isSearch && response.data.isBasicSearchLimitEnabled) {
          //   if (response.data.freeSearchCount == 5) {
          //     this.isFreeSearchesFinished = true;
          //   }
          //   const msg = response.data.freeSearchCount == 5 ? 'You have no free searches. Please upgrade to get unlimited search.' :
          //     `You have ${5 - response.data.freeSearchCount} free more searches. Please upgrade to get unlimited search.`
          //   this.confirm(msg);
          // }
          if (!this.autoTranshipmentSearch && this.searchResult && this.searchResult.length == 0) {
            this.autoTranshipmentSearch = true;
            this.toastr.warning("No direct sailings found! Please bear with us while we are looking for transhipment possibilities.");
            this.getscheduleRrouting(1);
            return;
          }


          this.totalCount = response.totalRecords;
          this.selectedShipIds = [];


          if (searchdata.ShippingLineIds == null || searchdata.ShippingLineIds == '') {
            if (response.data.shippingLineIds != null && response.data.shippingLineIds.length > 0) {
              response.data.shippingLineIds.forEach(element => {
                if(this.shippingLines){
                var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
                this.selectedShipIds.push(element.shippingLineId);
                }
              });
            }
          }
          else {
            var shipIds = searchdata.ShippingLineIds.split(',');
            if (shipIds != null) {
              for (var i = 0; i < shipIds.length; i++) {
                this.selectedShipIds.push(parseInt(shipIds[i]));
              }
            }
          }

          if (this.shippingLines != undefined && this.shippingLines != null) {
            this.selectedShipLines = this.shippingLines.filter(x => this.selectedShipIds.includes(x.shippingLineId));
          }
          // Transhipment Port filter
          if (this.scheduleRroute == ShippingLineRroute.Transhipment) {
            if (this.selectedTranshipmentPort == null) {
              if (response.data.midPorts != null && response.data.midPorts.length > 0) {
                this.transhipmentPorts = response.data.midPorts;
              }
            }
          }
          else {
            this.transhipmentPorts = [];
            this.selectedTranshipmentPort = null;
          }


        } else {
          if (response.code == '401') {
            openLoginModal();
          }
          // else if (response.Message == "Plan Expired" && this.isSearch) {
          //   this.isFreeSearchesFinished = true;
          //   this.confirm('You have no free searches. Please upgrade to get unlimited search.');
          // }
          else if (isPageLoad && this.searchResult && this.searchResult.length == 0) {
            this.toastr.warning("No direct sailings found!Please bear with us while we are looking for transhipment possibilities.");
            this.getscheduleRrouting(1);
          }

        }

        this.spinner.hide();

      },(err=>{
       if(err && err.error.message){
this.confirm(err.error.message);
      }
    }));
    }
  }

  SortbyQuckestDetails() {
    if (this.landingPageSearch != null && this.landingPageSearch != undefined) {
      var searchdata = new IdViewModel();
      searchdata.searchBy = SearchBy.Quickest;
      this.filterFlag = SearchBy.Quickest;
      searchdata.pageNo = this.currentPage;
      searchdata.recPerPage = this.pageSize;
      searchdata.fromPortIds = this.landingPageSearch.fromPortIds.toString();//parseInt(this.stateParams.fromPortId);
      searchdata.toPortIds = this.landingPageSearch.toPortIds.toString();//parseInt(this.stateParams.toPortId);
      searchdata.transhipment = this.scheduleRroute;
      searchdata.midPortId = this.selectedTranshipmentPort != null ? this.selectedTranshipmentPort.midPortId : 0;
      //searchdata.midPortId = this.selectedTranshipmentPort.midPortId
      if (this.timeFlag == true) {
        searchdata.searchDate = this.fromPortSliderSelectedDate;
        searchdata.toPortArrivalDate = this.toPortSliderSelectedDate;
      }
      else {
        searchdata.searchDate = this.landingPageSearch.date;
        searchdata.toPortArrivalDate = '';
      }

      searchdata.ShippingLineIds = (this.shippingIds == '' || this.shippingIds == null) ? '' : this.shippingIds;
      this.spinner.show();
      this.portService.SearchVoyages(searchdata,this.landingPageSearch.isCountrySearch).subscribe((response: any) => {
        if (response != null && response.data != null) {
          this.quckestsearchdata = response.data.voyage;
          this.searchResult = response.data.voyage;
          this.spinner.hide();
          if (this.searchResult != null) {
            // this.GetSliderarrivalandDep(this.searchResult[0].fromPortArrivalDate, this.searchResult[0].toPortArrivalDate);

          }
          this.totalCount = response.totalRecords;
          this.selectedShipIds = [];
          if (searchdata.ShippingLineIds == null || searchdata.ShippingLineIds == '') {
            if (response.data.shippingLineIds != null && response.data.shippingLineIds.length > 0) {
              response.data.shippingLineIds.forEach(element => {
                var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
                this.selectedShipIds.push(element.shippingLineId);
              });
            }

            // response.content.contents.forEach(element => {
            //   var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
            //   if (shippingdata != null) {
            //     this.selectedShipIds.push(element.shippingLineId);
            //   }
            // });
          }
          else {
            var shipIds = searchdata.ShippingLineIds.split(',');
            if (shipIds != null) {
              for (var i = 0; i < shipIds.length; i++) {
                this.selectedShipIds.push(parseInt(shipIds[i]));
              }
            }
          }
          this.selectedShipLines = this.shippingLines.filter(x => this.selectedShipIds.includes(x.shippingLineId));

          // Transhipment Port filter
          if (this.scheduleRroute == ShippingLineRroute.Transhipment) {
            if (this.selectedTranshipmentPort == null) {
              if (response.data.midPorts != null && response.data.midPorts.length > 0) {
                this.transhipmentPorts = response.data.midPorts;
              }
            }
          }
          else {
            this.transhipmentPorts = [];
            this.selectedTranshipmentPort = null;
          }

          this.Quickestserchres = [];
          this.quckestsearchdata.forEach(obj => {
            let quick: QuickestSearchModel = {};
            quick.LogoUrl = obj.companyLogo === null ? "" : obj.companyLogo;
            quick.voyageId = obj.id;
            quick.vesselsId = obj.vesselsId;
            quick.fromPortDepartureDate = this.dateConvert(obj.fromPortArrivalDate);
            quick.toPortArrivalDate = this.dateConvert(obj.toPortArrivalDate);
            quick.toCompanyLogo = obj.toCompanyLogo;
            quick.isTranshipment = obj.isTranshipment;
            quick.vesselsName = obj.vesselsName;
            quick.fromPortId = obj.fromPortId;
            quick.fromPortName = obj.fromPortName;
            quick.toPortId = obj.toPortId;
            quick.toPortName = obj.toPortName;
            quick.midPortName = obj.midPortName;
            quick.midPortArrivalDate = this.dateConvert(obj.midPortArrivalDate);
            quick.midPortDepartureDate = this.dateConvert(obj.midPortDepartureDate);
            quick.toVesselsName = obj.toVesselsName;
            quick.midPortId = obj.midPortId;
            quick.toVesselsId = obj.toVesselsId;
            quick.shippingLineId = obj.shippingLineId;

            let lables = [];
            let DataDay = [];
            let DataRate = [];
            lables.push(obj.vesselsName);
            DataDay.push(obj.noOfDays);
            obj.cubicMeter = obj.cubicMeter == null ? 0 : obj.cubicMeter;
            DataRate.push(obj.cubicMeter);
            let dis = {
              labels: lables,
              datasets: [
                {
                  label: 'Days',
                  data: DataDay,
                  backgroundColor: '#6DCFD1',
                },
                {
                  label: 'Rate',
                  data: DataRate,
                  backgroundColor: '#1F232A',
                }
              ],
            }
            quick.quickestdata = dis;
            this.Quickestserchres.push(quick);
            //this.logos.push(obj.companyLogo);
          });

          this.optionsquick = {
            legend: {
              position: 'bottom'
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: true,
                  gridLines: {
                    display: true,
                  },
                },
                ticks: {
                  beginAtZero: true,
                  // max: 100
                }
              }],
              yAxes: [{
                display: false,
                gridLines: {
                  display: false,
                }
              }
              ],
            }
          };
        }
        else if (response.code == '401') {
          openLoginModal();
        }
        this.spinner.hide();
      })
    }
  }

  SortbyChepestDetails() {
    if (this.landingPageSearch != null && this.landingPageSearch != undefined) {
      var searchdata = new IdViewModel();
      searchdata.searchBy = SearchBy.Cheapest;
      this.filterFlag = SearchBy.Cheapest;
      searchdata.pageNo = this.currentPage;
      searchdata.recPerPage = this.pageSize;
      searchdata.fromPortIds = this.landingPageSearch.fromPortIds.toString();//parseInt(this.stateParams.fromPortId);
      searchdata.toPortIds = this.landingPageSearch.toPortIds.toString();//parseInt(this.stateParams.toPortId);
      searchdata.transhipment = this.scheduleRroute;
      searchdata.midPortId = this.selectedTranshipmentPort != null ? this.selectedTranshipmentPort.midPortId : 0;
      if (this.timeFlag == true) {
        searchdata.searchDate = this.fromPortSliderSelectedDate;
        searchdata.toPortArrivalDate = this.toPortSliderSelectedDate;
      }
      else {
        searchdata.searchDate = this.landingPageSearch.date;
        searchdata.toPortArrivalDate = '';
      }

      searchdata.ShippingLineIds = (this.shippingIds == '' || this.shippingIds == null) ? '' : this.shippingIds;
      this.spinner.show();
      this.portService.SearchVoyages(searchdata,this.landingPageSearch.isCountrySearch).subscribe((response: any) => {
        if (response != null && response.data != null) {
          this.chepestsearchdata = response.data.voyage;
          this.searchResult = response.data.voyage;
          //this.spinner.hide();
          if (this.searchResult != null) {
            // this.GetSliderarrivalandDep(this.searchResult[0].fromPortArrivalDate, this.searchResult[0].toPortArrivalDate);

          }
          this.totalCount = response.totalRecords;

          this.selectedShipIds = [];
          if (searchdata.ShippingLineIds == null || searchdata.ShippingLineIds == '') {
            if (response.data.shippingLineIds != null && response.data.shippingLineIds.length > 0) {
              response.data.shippingLineIds.forEach(element => {
                var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
                this.selectedShipIds.push(element.shippingLineId);
              });
            }

            // response.content.contents.forEach(element => {
            //   var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
            //   if (shippingdata != null) {
            //     this.selectedShipIds.push(element.shippingLineId);
            //   }
            // });
          }
          else {
            var shipIds = searchdata.ShippingLineIds.split(',');
            if (shipIds != null) {
              for (var i = 0; i < shipIds.length; i++) {
                this.selectedShipIds.push(parseInt(shipIds[i]));
              }
            }
          }
          this.selectedShipLines = this.shippingLines.filter(x => this.selectedShipIds.includes(x.shippingLineId));

          // Transhipment Port filter
          if (this.scheduleRroute == ShippingLineRroute.Transhipment) {
            if (this.selectedTranshipmentPort == null) {
              if (response.data.midPorts != null && response.data.midPorts.length > 0) {
                this.transhipmentPorts = response.data.midPorts;
              }
            }
          }
          else {
            this.transhipmentPorts = [];
            this.selectedTranshipmentPort = null;
          }

          this.chepestserchres = [];
          this.chepestsearchdata.forEach(obj => {
            let quick: QuickestSearchModel = {};
            quick.LogoUrl = obj.companyLogo === null ? "" : obj.companyLogo;
            quick.voyageId = obj.id;
            quick.vesselsId = obj.vesselsId;
            quick.fromPortDepartureDate = this.dateConvert(obj.fromPortArrivalDate);
            quick.toPortArrivalDate = this.dateConvert(obj.toPortArrivalDate);
            quick.toCompanyLogo = obj.toCompanyLogo;
            quick.isTranshipment = obj.isTranshipment;
            quick.vesselsName = obj.vesselsName;
            quick.fromPortId = obj.fromPortId;
            quick.fromPortName = obj.fromPortName;
            quick.toPortId = obj.toPortId;
            quick.toPortName = obj.toPortName;
            quick.midPortName = obj.midPortName;
            quick.midPortArrivalDate = this.dateConvert(obj.midPortArrivalDate);
            quick.midPortDepartureDate = this.dateConvert(obj.midPortDepartureDate);
            quick.toVesselsName = obj.toVesselsName;
            quick.midPortId = obj.midPortId;
            quick.toVesselsId = obj.toVesselsId;
            let lables = [];
            let DataDay = [];
            let DataRate = [];
            lables.push(obj.vesselsName);
            DataDay.push(obj.noOfDays);
            DataRate.push(obj.cubicMeter);
            let dis = {
              labels: lables,
              datasets: [
                {
                  label: 'Days',
                  data: DataDay,
                  backgroundColor: '#6DCFD1',
                },
                {
                  label: 'Rate',
                  data: DataRate,
                  backgroundColor: '#1F232A',
                }
              ],
            }
            quick.quickestdata = dis;
            this.chepestserchres.push(quick);
            //this.logos.push(obj.companyLogo);
          });

          this.optionsquick = {
            legend: {
              position: 'bottom'
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: true,
                  gridLines: {
                    display: true,
                  },
                },
                ticks: {
                  beginAtZero: true,
                  // max: 100
                }
              }],
              yAxes: [{
                display: false,
                gridLines: {
                  display: false,
                }
              }
              ],
            }
          };
        }
        else if (response.code == '401') {
          openLoginModal();
        }
        this.spinner.hide();
      })
    }
  }


  getPortsData() {
    if (this.landingPageSearch != null && this.landingPageSearch != undefined) {
      var searchdata = new IdViewModel();
      searchdata.fromPortIds = this.landingPageSearch.fromPortIds.toString();//parseInt(this.stateParams.fromPortId);
      searchdata.toPortIds = this.landingPageSearch.toPortIds.toString();//parseInt(this.stateParams.toPortId);
      this.portService.GetPortdata(searchdata).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.portsData = response.content;

          // response.content.forEach(element => {
          //   if (element.id == this.stateParams.fromPortId) {
          //     this.searchForm.controls.fromPort.setValue(element);
          //     this.departurePortName = element.portName;
          //   }
          //   if (element.id == this.stateParams.toPortId) {
          //     this.searchForm.controls.toPort.setValue(element);
          //     this.arrivalPortName = element.portName;
          //   }
          // });
          let newDate = new Date(this.landingPageSearch.date);
          this.searchForm.controls.date.setValue(newDate as any);
        }
      });
    }
  }
  getShippingLines() {
    this.portService.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippingLines = response.content;
      }
    })
  }
  getSelectedShippingLine(event) {
    this.selectedShipLines = [];
    if (event.value != null) {
      this.selectedShipLines = event.value;
      this.shippingIds = '';
      if (this.selectedShipLines != null && this.selectedShipLines.length > 0) {
        this.selectedShipLines.forEach(element => {
          if (this.shippingIds == '') {
            this.shippingIds = element.shippingLineId.toString();
          }
          else {
            this.shippingIds = this.shippingIds + ',' + element.shippingLineId;
          }
        });
      }
      if (this.filterFlag == SearchBy.Quickest) {
        this.SortbyQuckestDetails();
      }
      else if (this.filterFlag == SearchBy.Cheapest) {
        this.currentPage = 1;
        this.isSearch = false;
        this.SortbyChepestDetails();
      }
      else {
        this.currentPage = 1;
        this.isSearch = false;
        this.getSearchResult();
      }

    }

  }

  onSearch() {
    if(this.isOpenSearchEnabled && !this.areOpenSearcAndFormValuesSame()){
      return false;
    }else{
      this.totalCount = null;
      this.submitted = true;
  
      this.timeFlag = false;
      // stop here if form is invalid
      if (this.searchForm.invalid) {
        return;
      }
      // else if (this.isFreeSearchesFinished && this.isBasicPlan) {
      //   this.confirm('You have no free searches. Please upgrade to get unlimited search.');
      // }
      else {
  
        var data: any = this.searchForm.value;
        if (data != null &&
          data.toCountry != null &&
          data.fromCountry != null &&
          data.fromPort != null &&
          data.toPort != null) {
          if (this.isBasicPlan == true) {
            this.isSearch = true;
            this.totalSearchCount = (this.totalSearchCount != null && this.totalSearchCount > 0) ? this.totalSearchCount : 0
            this.totalSearchCount = this.totalSearchCount + 1;
            this.currentUserDetails.usersDetailsVM.totalSearchCount = this.totalSearchCount;
            localStorage.setItem("currentUser", JSON.stringify(this.currentUserDetails));
          }
  
          let date: any = this.dateConvert(this.searchForm.value.date);
          if (data.fromCountry.id > 0 && data.toCountry.id > 0 && data.fromPort.length > 0 && data.toPort.length > 0) {
  
            this.landingPageSearch.date = date;
            this.landingPageSearch.toCountryId = data.toCountry.id;
            this.landingPageSearch.toPortIds = data.toPort.map(x => x.id);
            this.landingPageSearch.fromCountryId = data.fromCountry.id;
            this.landingPageSearch.fromPortIds = data.fromPort.map(x => x.id);
            this.landingPageSearch.isSearch = this.isSearch;
            this.landingPageSearch.isCountrySearch = false;
            localStorage.setItem(DataParam.LandingPageSearch.toString(), JSON.stringify(this.landingPageSearch))
            this.scheduleRroute = 0;
            this.autoTranshipmentSearch = false;
            this.getSearchResult();
          }
          else {
            this.toastr.error("Incorrect port", "Error");
          }
        }
      }
    }
   
  }
  

  onSearchByCountry() {
    if(this.isOpenSearchEnabled && !this.areOpenSearcAndFormValuesSame()){
      return false;
    }else{
      this.totalCount = null;
      this.submitted = true;
  
      this.timeFlag = false;
      // stop here if form is invalid
      if (this.searchForm.invalid) {
        return;
      }
      // else if (this.isFreeSearchesFinished && this.isBasicPlan) {
      //   this.confirm('You have no free searches. Please upgrade to get unlimited search.');
      // }
      else {
  
        var data: any = this.searchForm.value;
        if (data != null &&
          data.toCountry != null &&
          data.fromCountry != null) {
          if (this.isBasicPlan == true) {
            this.isSearch = true;
            this.totalSearchCount = (this.totalSearchCount != null && this.totalSearchCount > 0) ? this.totalSearchCount : 0
            this.totalSearchCount = this.totalSearchCount + 1;
            this.currentUserDetails.usersDetailsVM.totalSearchCount = this.totalSearchCount;
            localStorage.setItem("currentUser", JSON.stringify(this.currentUserDetails));
          }
          if(this.isCountrySearch){
            let date = this.dateConvert(this.searchForm.value.date);
            if (data.fromCountry.id > 0 && data.toCountry.id > 0 ) {
    
              this.landingPageSearch.date = date;
              this.landingPageSearch.toCountryId = data.toCountry.id;
              this.landingPageSearch.fromCountryId = data.fromCountry.id;
              this.landingPageSearch.isSearch = this.isSearch;
              this.landingPageSearch.isCountrySearch = true;
              localStorage.setItem(DataParam.LandingPageSearch.toString(), JSON.stringify(this.landingPageSearch))
              this.scheduleRroute = 0;
              this.autoTranshipmentSearch = false;
              this.getSearchResult();
            }
            else {
              this.toastr.error("Incorrect port", "Error");
            }
          }else{
            let date = this.dateConvert(this.searchForm.value.date);
          if (data.fromCountry.id > 0 && data.toCountry.id > 0 && data.fromPort.length > 0 && data.toPort.length > 0) {
  
            this.landingPageSearch.date = date;
            this.landingPageSearch.toCountryId = data.toCountry.id;
            this.landingPageSearch.fromCountryId = data.fromCountry.id;
            this.landingPageSearch.isSearch = this.isSearch;
            this.landingPageSearch.isCountrySearch = true;
            localStorage.setItem(DataParam.LandingPageSearch.toString(), JSON.stringify(this.landingPageSearch))
            this.scheduleRroute = 0;
            this.autoTranshipmentSearch = false;
            this.getSearchResult();
          }
          else {
            this.toastr.error("Incorrect port", "Error");
          }
        }
        }
      }
    }
   
  }

  areOpenSearcAndFormValuesSame() {
    var data: any = this.searchForm.value;    
    const fromCountryId = this.openSearches.find(z=>z.fieldName== OpenSearchFinderFields.FromCountry);
    const toCountryId = this.openSearches.find(z=>z.fieldName== OpenSearchFinderFields.ToCountry);
    const fromPortId = this.openSearches.find(z=>z.fieldName== OpenSearchFinderFields.FromPort);
    const toPortId = this.openSearches.find(z=>z.fieldName== OpenSearchFinderFields.ToPort);
    if (data.fromCountry.id != +fromCountryId.fieldValue
      || data.toCountry.id != +toCountryId.fieldValue
      || data.fromPort[0].id != +fromPortId.fieldValue
      || data.toPort[0].id != +toPortId.fieldValue) {    
        this.toastr.warning(`Please register to use the port-to-port search. It's completely FREE.`);    
      return false;
    }
    return true;

  }

  paginate(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.isSearch = false;
    this.getSearchResult();
  }

  paginatequickest(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.SortbyQuckestDetails();
  }

  paginatechepest(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.SortbyChepestDetails();
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  dateConvertSlider(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");

  }

  removeShips(ship) {
    if (ship != null) {
      if (this.selectedShipLines != null && this.selectedShipLines.length > 1) {
        const index: number = this.selectedShipLines.indexOf(ship);
        if (index !== -1) {
          this.selectedShipLines.splice(index, 1);
          this.shippingIds = '';
          this.selectedShipLines.forEach(element => {
            if (this.shippingIds == '') {
              this.shippingIds = element.shippingLineId.toString();
            }
            else {
              this.shippingIds = this.shippingIds + ',' + element.shippingLineId;
            }
          });
        }
        if (this.filterFlag == SearchBy.Quickest) {
          this.SortbyQuckestDetails();
        }
        else if (this.filterFlag == SearchBy.Cheapest) {
          this.currentPage = 1;
          this.isSearch = false;
          this.SortbyChepestDetails();
        }
        else {
          this.currentPage = 1;
          this.isSearch = false;
          this.getSearchResult();
        }
      }
      else {
        this.toastr.info('You can not remove all Shipping lines', 'Info')
      }
    }
  }


  createSliderForDeparture(fromportdatedep) {
    this.IsFilter = true;
    this.dateRange = this.createDateRange(fromportdatedep);
    this.valueArrival = this.dateRange[0].getTime();
    this.arroption = {
      stepsArray: this.dateRange.map((date: Date) => {
        return { value: date.getTime() };
      }),
      translate: (value: number): string => {

        // this.fromPortSliderSelectedDate = this.dateConvert(new Date(value).toDateString());
        // return this.dateConvert(new Date(value).toDateString());
        this.fromPortSliderSelectedDate = this.dateConvertSlider(new Date(value).toDateString());
        return this.dateConvertSlider(new Date(value).toDateString());
      }
    };
  }

  createSliderForArrival(toportarrival) {
    this.depselectedDate = this.createDepartureDateRange(toportarrival);
    this.valueDep = this.depselectedDate[119].getTime();
    this.OptionsDep = {
      stepsArray: this.depselectedDate.map((date: Date) => {
        return { value: date.getTime() };
      }),
      translate: (value: number): string => {
        // this.toPortSliderSelectedDate = this.dateConvert(new Date(value).toDateString());
        // return this.dateConvert(new Date(value).toDateString());
        this.toPortSliderSelectedDate = this.dateConvertSlider(new Date(value).toDateString());
        return this.dateConvertSlider(new Date(value).toDateString());
      }
    };
  }

  createDateRange(arrdate): Date[] {
    const dates: Date[] = [];
    for (let i: number = 0; i < 120; i++) {
      let arrdate1 = new Date(arrdate);
      var dd = arrdate1.getDate() + i;
      var mm = arrdate1.getMonth();
      var y = arrdate1.getFullYear();
      dates.push(new Date(y, mm, dd));
    }
    this.toportarrivalladd30days = dates[29];
    return dates;
  }

  createDepartureDateRange(datedepport): Date[] {
    const dates: Date[] = [];
    for (let i: number = 0; i < 120; i++) {
      let arrdate1 = new Date(datedepport);
      var dd = arrdate1.getDate() + i;
      var mm = arrdate1.getMonth();
      var y = arrdate1.getFullYear();
      dates.push(new Date(y, mm, dd));
    }
    this.fromportarrivaladd30days = dates[29];
    return dates;
  }

  toPortChangeSlidder(val) {
    this.timeFlag = true;
    let date = new Date(val.value).toDateString();
    this.toPortSliderSelectedDate = this.dateConvert(date);
    if (this.fromPortSliderSelectedDate) {
      const dateSplit = this.fromPortSliderSelectedDate.split('-');
      if (dateSplit.length > 0 && dateSplit[0].length === 2) {
        let date = moment(this.fromPortSliderSelectedDate, "DD-MM-YYYY");
        this.fromPortSliderSelectedDate = date.format('YYYY-MM-DD');
      }
    }
    if (this.filterFlag == SearchBy.Quickest) {
      this.SortbyQuckestDetails();
    }
    else if (this.filterFlag == SearchBy.Cheapest) {
      this.currentPage = 1;
      this.isSearch = false;
      this.SortbyChepestDetails();
    }
    else {
      this.currentPage = 1;
      this.isSearch = false;
      this.getSearchResult();
    }

  }

  fromPortChangeSlidder(val) {
    this.timeFlag = true;
    let date = new Date(val.value).toDateString();
    this.fromPortSliderSelectedDate = this.dateConvert(date);
    if (this.toPortSliderSelectedDate) {
      const dateSplit = this.toPortSliderSelectedDate.split('-');
      if (dateSplit.length > 0 && dateSplit[0].length === 2) {
        let date = moment(this.toPortSliderSelectedDate, "DD-MM-YYYY");
        this.toPortSliderSelectedDate = date.format('YYYY-MM-DD');
      }
    }
    if (this.filterFlag == SearchBy.Quickest) {
      this.SortbyQuckestDetails();
    }
    else if (this.filterFlag == SearchBy.Cheapest) {
      this.currentPage = 1;
      this.isSearch = false;
      this.SortbyChepestDetails();
    }
    else {
      this.currentPage = 1;
      this.isSearch = false;
      this.getSearchResult();
    }
  }

  getDetails(id, fromDate, toDate, fromPortId, toPortId, shippingLineId) {
    // if (this.isBasicPlan) {
    //   this.confirm('Please upgrade to see full schedule.');
    // }
    if (id > 0 && (fromDate != null && fromDate != '') && (toDate != null && toDate != '')) {
      let fromdate = this.dateConvert(fromDate);
      let todate = this.dateConvert(toDate);
      var currentUser = localStorage.getItem('currentUser');

      if (currentUser) {
        const url = '/' + 'voyagedetail' + '/' + id + '/' + fromPortId + '/' + toPortId + '/' + fromdate + '/' + todate + '/' + shippingLineId;
        this.router.navigate([url]);
      }

      else {
        var voyageData = {
          id: id,
          page: 'voyagedetail',
          fromPortId: fromPortId,
          toPortId: toPortId,
          isTrashipment: 0,
          fromDate: fromdate,
          toDate: todate
        };
        localStorage.setItem('voyagedetailspage', JSON.stringify(voyageData));
        openLoginModal();
        //this.router.navigate(['/login']);
      }
    }
  }

  getTranshipmentVoyage(vesselsId, toVesselsId, midPortId, fromDate, toDate, fromPortId, toPortId, shippingLineId, toShippingLineId) {
    if (vesselsId > 0 && toVesselsId > 0 && midPortId > 0 && (fromDate != null && fromDate != '') && (toDate != null && toDate != '')) {
      let fromdate = this.dateConvert(fromDate);
      let todate = this.dateConvert(toDate);
      let currentUser = localStorage.getItem('currentUser');

      if (currentUser) {
        const url = '/' + 'voyagedetail' + '/' + vesselsId + '/' + toVesselsId +
          '/' + fromPortId + '/' + toPortId + '/' + midPortId + '/' + 1 + '/' + fromdate + '/' + todate + '/' + shippingLineId + '/' + toShippingLineId;
        // var url1 = '/' + 'voyagedetail' + '/' + vesselsId + '/' + this.stateParams.fromPortId + '/' + this.stateParams.toPortId + '/' + fromdate + '/' + todate;
        this.router.navigate([url]);
      }
      else {
        var voyageData = {
          id: vesselsId,
          toVesselsId: toVesselsId,
          page: 'voyagedetail',
          fromPortId: fromPortId,
          toPortId: toPortId,
          midPortId: midPortId,
          isTrashipment: 1,
          fromDate: fromdate,
          toDate: todate
        };
        localStorage.setItem('voyagedetailspage', JSON.stringify(voyageData));
        //this.router.navigate(['/login']);
        openLoginModal();
      }
    }
  }

  getPortDatafordropdown() {
    this.portService.GetPortData().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.portsData = response.content;
      }
    });
  }

  getscheduleRrouting(route) {
    this.totalCount = null;
    this.spinner.show();
    if (route == 0 || route == 1) {
      this.spinner.show();
      this.scheduleRroute = route;
      //this.gettransittimedetails();
      this.selectedShipLines = [];
      this.shippingIds = '';
      this.timeFlag = false;
      // create Departure Slider
      // this.createSliderForDeparture(this.stateParams.date);
      // create Departure Slider
      // this.createSliderForArrival(this.newDate);
      if (this.tap == SearchBy.Quickest) {
        this.currentPage = 1;
        this.isSearch = false;
        this.SortbyQuckestDetails();
      }
      else if (this.tap == SearchBy.Cheapest) {
        this.currentPage = 1;
        this.isSearch = false;
        this.SortbyChepestDetails();
      }
      else {
        this.currentPage = 1;
        this.isSearch = false;
        this.getSearchResult();
      }
    }
  }

  filterByTranshipmentPorts(event) {
    if (event) {
      this.selectedTranshipmentPort = event.value;

      if (this.tap == SearchBy.Quickest) {
        this.currentPage = 1;
        this.isSearch = false;
        this.SortbyQuckestDetails();
      }
      else if (this.tap == SearchBy.Cheapest) {
        this.currentPage = 1;
        this.isSearch = false;
        this.SortbyChepestDetails();
      }
      else {
        this.currentPage = 1;
        this.isSearch = false;
        this.getSearchResult();
      }
    }
  }

  getRateRequest(shipId, fromPortId, toPortId) {
    if (shipId > 0 && fromPortId > 0 && toPortId > 0) {

      var currentUser = localStorage.getItem('currentUser');
      if (currentUser != null && currentUser != undefined) {
        var url = '/' + 'raterequest' + '/' + shipId + '/' + fromPortId + '/' + toPortId;
        this.router.navigate([url]);
      }
      else {
        var url = '/' + 'freightquotation' + '/' + shipId + '/' + fromPortId + '/' + toPortId;
        this.router.navigate([url]);
        // var rateRequestData = {
        //   page: 'freightquotation',
        //   fromPortId: this.stateParams.fromPortId,
        //   toPortId: this.stateParams.toPortId,
        //   shipsId: shipId
        // };
        // localStorage.setItem('raterequestpage', JSON.stringify(rateRequestData));
        // this.router.navigate(['/freightquotation']);
      }
    }
  }

  tracking(shipId, vesselsId, fromPortArrivalDate, isTranshipment, fromPortId, toPortId) {
    if(!this.enableTracking){
      const msg =  'Your existing plan does not allow track voyage. Please upgrade the plan';
    this.confirm(msg);
    }
    else if (fromPortId > 0 && toPortId > 0) {
      var fromDate = this.dateConvert(this.searchForm.value.date);
      if (shipId > 0 && vesselsId > 0) {
        
        var currentUser = localStorage.getItem('currentUser');

        if (currentUser) {
          var url = '/' + 'tracking' + '/' + shipId + '/' + vesselsId + '/' + fromPortId + '/' + toPortId + '/' + fromDate;
          this.router.navigate([url]);
        }

        else {
          var trackingData = {
            page: 'tracking',
            fromPortId: fromPortId,
            toPortId: toPortId,
            shipsId: shipId,
            vesselId: vesselsId,
            DeptDate: fromDate
          };
          localStorage.setItem('trackingpage', JSON.stringify(trackingData));
          //this.router.navigate(['/login']);
          openLoginModal();
        }
      }
    }
  }

  getDestinationCountries(fromCountryId, fromPortIds, isSetDefault: boolean) {
    this.portService.getDestinationCountryList(fromCountryId, fromPortIds).subscribe((response: any) => {
      if (response != null && response.succeeded && response.data != null) {
        this.masterDestinationCountries = response.data;
        if (this.landingPageSearch != null && isSetDefault && this.landingPageSearch.toCountryId > 0) {
          for (let element of this.masterDestinationCountries) {
            if (element.id == this.landingPageSearch.toCountryId) {
              this.searchForm.controls.toCountry.setValue(element as any);
            }
          }
        }
      }
    });
  }

  getDestinationPorts(toCountryId, fromPortIds, isSetDefault: boolean) {
    this.portService.getDestinationPortList(toCountryId, fromPortIds).subscribe((response: any) => {
      if (response != null && response.succeeded && response.data != null) {
        this.masterDestinationPorts = response.data;

        if (this.landingPageSearch != null && isSetDefault && this.landingPageSearch.toPortIds.length > 0) {
          let selectedToPorts: any = this.masterDestinationPorts.filter(x => this.landingPageSearch.toPortIds.includes(x.id));
          if (selectedToPorts.length <= 5) {
            this.searchForm.controls.toPort.setValue(selectedToPorts);
          }
        }
      }
    });
  }

  getSourceCountries(isSetDefault: boolean) {
    this.portService.getSourceCountryList().subscribe((response: any) => {
      if (response != null && response.succeeded && response.data != null) {
        this.masterSourceCountries = response.data;
        if(this.isCountrySearch){
         this.masterDestinationCountries=this.masterSourceCountries;
        }
        if (this.landingPageSearch != null && isSetDefault && this.landingPageSearch.fromCountryId > 0) {
          for (let element of this.masterSourceCountries) {
            if (element.id == this.landingPageSearch.fromCountryId) {
              this.searchForm.controls.fromCountry.setValue(element as any);
            }
            if (element.id == this.landingPageSearch.toCountryId) {
                  this.searchForm.controls.toCountry.setValue(element as any);
            }
          }
        }
      }
    });
  }

  getSourcePorts(toCountryId, isSetDefault: boolean) {
    this.portService.getSourcePortList(toCountryId).subscribe((response: any) => {
      if (response != null && response.succeeded && response.data != null) {
        this.masterSourcePorts = response.data;
        if (this.landingPageSearch != null && isSetDefault && this.landingPageSearch.fromPortIds.length > 0) {
          let selectedFromPorts: any = this.masterSourcePorts.filter(x => this.landingPageSearch.fromPortIds.includes(x.id));
          if (selectedFromPorts.length <= 5) {
            this.searchForm.controls.fromPort.setValue(selectedFromPorts);
          }
        }
      }
    });
  }

  onDestinationCountrySelect(event) {
    if(!this.isCountrySearch){
    this.resetDestinationPorts();
    let portIds = (this.searchForm.value.fromPort as any)?.map(x => x.id);
    if (portIds.length > 0) {
      this.getDestinationPorts(event.value.id, portIds, false);
    }
  }
  }

  onSourcePortChange(event) {
    this.resetDestinationCountries();
    let fromCountryId = (this.searchForm.value.fromCountry as any)?.id;
    let fromPortIds = event.value.map(x => x.id);
    if (fromPortIds.length > 0) {
      this.getDestinationCountries(fromCountryId, fromPortIds, false);
    }
  }

  onSourceCountrySelect(event) {
    if(this.isCountrySearch){
      this.searchForm.controls.toCountry.reset();
      this.searchForm.controls.toCountry.setValue({} as any);
    }else{
    this.resetSourcePorts();

    this.getSourcePorts(event.value.id, false);
    }

  }

  resetSourcePorts() {
    this.searchForm.controls.fromPort.reset();
    this.searchForm.controls.fromPort.setValue([] as any);
    this.masterSourcePorts = [];
    this.resetDestinationCountries();
  }

  resetDestinationCountries() {
    this.searchForm.controls.toCountry.reset();
    this.searchForm.controls.toCountry.setValue({} as any);
    this.masterDestinationCountries = [];
    this.resetDestinationPorts();
  }

  resetDestinationPorts() {
    this.searchForm.controls.toPort.reset();
    this.searchForm.controls.toPort.setValue([] as any);
    this.masterDestinationPorts = [];
  }

  ResetSearchFilter() {
    localStorage.removeItem(DataParam.LandingPageSearch.toString());
    this.searchForm.controls.toCountry.reset();
    this.searchForm.controls.toCountry.setValue({} as any);
    this.searchForm.controls.date.setValue("");
    this.resetSourcePorts();
  }

  confirm(message, yesButtonText = 'Upgrade', noButtonText = 'No') {
    this.yesButtonText = yesButtonText;
    this.noButtonText = noButtonText;
    this.confirmationService.confirm({
      message: message,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.router.navigateByUrl('/planselection');
      },
      reject: () => {
      }
    });
  }

  getOpenSearches(){
    var currentUser = localStorage.getItem('currentUser');
    if (!currentUser) {
    this.openSearchService.getOpenSearchByFeatureName(OpenSearchScreen.Finder).subscribe((res: Result<FreeSearchConfigVM>)=>{
      if(res && res.data && res.data){        
        this.openSearches=res.data.openSearchConfig;
        this.isOpenSearchEnabled =true;
      }
    });
  }
  }

}
